import * as React from 'react';
import { ModalHeader, ModalContents } from '../../components/modal/modal';
import { ExternalLink, Link } from '../../primitives/link/link';
import { ButtonStyle } from '../../primitives/button/button';
import { ButtonLink } from '../../primitives/button/button-link';
import { buildKioskLink, KioskLinkDetails } from '../../utils/kiosk-link';
import { WebGivingPushpayInfo } from '../../webgiving-generated';
import { Text } from '../../components/text';

import { footer, buttonContainer } from './mobile-sign-in-info-modal.less';

export interface IMobileSignInInfoModalProps {
	pushpayInfo: WebGivingPushpayInfo;
	kioskLinkDetails: KioskLinkDetails;
	showAccountLinks?: boolean;
	showKioskLinks?: boolean;
}

export class MobileSignInInfoModalHeader extends React.Component {
	render() {
		return <ModalHeader text="How does mobile sign in work?" />;
	}
}

export class MobileSignInInfoModalContent extends React.Component<IMobileSignInInfoModalProps> {
	render() {
		const { kioskLinkDetails, pushpayInfo: { ManageAccountUrl, ResetPasswordUrl }, showAccountLinks, showKioskLinks } = this.props;

		return (
			<ModalContents>
				<div className="lead">
					{/* tslint:disable:max-line-length */}
					<p><Text>Mobile sign in streamlines your giving by allowing you to sign in with a security code. The way it works is simple. We will text the security code to your mobile phone, or we can send it via voice call.</Text></p>
					<p><Text>You no longer need to remember a password! The security code replaces the need to remember one. Managing your account and giving has never been so secure.</Text></p>
					<p><Text>If you wish to sign in via email &amp; password, you will need to create a password. This can be achieved by using the</Text> <Link branded inheritFontSize acceptanceTestTargetId="Set a new Password" href={ResetPasswordUrl}><Text>Set a new Password</Text></Link> <Text>link. Please note, this only applies if you have already created an account.</Text></p>
					{/* tslint:enable:max-line-length */}
				</div>
				{(showAccountLinks || showKioskLinks) && <div className={footer}>
					{showAccountLinks && (
						<>
							<p>
								<Text>If you have an account already</Text>
							</p>
							<div className={`${buttonContainer} col-sm-6`}>
								<ButtonLink
									buttonStyle={ButtonStyle.Ghost}
									acceptanceTestTargetId="Sign in via email password"
									href={ManageAccountUrl}
								>
									<Text>Sign in via email &amp; password</Text>
								</ButtonLink>
							</div>
						</>
					)}
					{ showKioskLinks && <KioskLink kioskLinkDetails={kioskLinkDetails} /> }
				</div>}
			</ModalContents>
		);
	}
}

const KioskLink: React.StatelessComponent<{ children?: React.ReactNode, kioskLinkDetails: KioskLinkDetails }> = (props) => {
	const { kioskLinkDetails } = props;

	{/* tslint:disable:max-line-length */ }
	return kioskLinkDetails.supported ? (
		<p><Text>or</Text> <ExternalLink acceptanceTestTargetId="Give as guest" href={buildKioskLink('wg-guest', kioskLinkDetails)} branded={false}><Text>Give as guest</Text></ExternalLink></p>
	) : null;
	{/* tslint:enable:max-line-length */ }
};
